import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "kpis" }
const _hoisted_2 = { class: "kpi__label" }
const _hoisted_3 = { class: "kpi__value" }
const _hoisted_4 = { class: "open-invoices" }
const _hoisted_5 = { class: "open-invoices-body" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = {
  key: 0,
  class: "open-invoices-header checkbox"
}
const _hoisted_8 = { class: "open-invoices-header invoiceNumber" }
const _hoisted_9 = { class: "open-invoices-header client" }
const _hoisted_10 = { class: "open-invoices-header company" }
const _hoisted_11 = { class: "open-invoices-header total" }
const _hoisted_12 = { class: "open-invoices-header paid" }
const _hoisted_13 = { class: "open-invoices-header balance" }
const _hoisted_14 = { class: "open-invoices-header dueDate" }
const _hoisted_15 = { class: "open-invoices-header nbReminders" }
const _hoisted_16 = { class: "open-invoices-header promisedDate" }
const _hoisted_17 = { class: "open-invoices-header comment" }
const _hoisted_18 = { class: "open-invoices-header comment" }
const _hoisted_19 = { class: "open-invoices-header paymentOption" }
const _hoisted_20 = { class: "open-invoices-header collectionStatus" }
const _hoisted_21 = { class: "open-invoices-header assignedTo" }
const _hoisted_22 = {
  key: 0,
  class: "loading apollo"
}
const _hoisted_23 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginatedEntitiesList = _resolveComponent("PaginatedEntitiesList")!
  const _component_EditInvoice = _resolveComponent("EditInvoice")!
  const _component_BasicButton = _resolveComponent("BasicButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpis, (kpi, key) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "kpi",
          key: key
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(kpi.label), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(kpi.value), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          (_ctx.hasCheckBox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectAll) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAll]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("labels.invoiceNumber")), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t("labels.client")), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("labels.company")), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("labels.total")), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t("labels.paid")), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t("labels.balance")), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t("labels.dueDate")), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t("labels.nbReminders")), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t("labels.promisedDate")), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("labels.communication")), 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t("labels.comment")), 1),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t("labels.paymentOption")), 1),
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("labels.collectionStatus")), 1),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("labels.assignedTo")), 1)
        ]),
        _createVNode(_component_PaginatedEntitiesList, {
          query: _ctx.GET_OPENED_INVOICES,
          "query-params": _ctx.queryParams,
          checkBoxes: _ctx.checkBoxes,
          "onUpdate:checkBoxes": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkBoxes) = $event)),
          selectAll: _ctx.selectAll,
          "onUpdate:selectAll": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectAll) = $event)),
          items: _ctx.openedInvoices,
          "onUpdate:items": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.openedInvoices) = $event)),
          hasIcon: false,
          hasCheckBox: _ctx.hasCheckBox,
          avatarColumn: 'assignedTo',
          linkableColumns: {
          client: (invoice) => ({
            name: 'ClientUsers',
            params: { id: invoice.company.client.id },
          }),
        },
          formatters: {
          client: _ctx.formatClient,
          paid: _ctx.formatPaid,
          nbReminders: _ctx.reminderCount,
          dueDate: _ctx.formatDate,
          promisedDate: _ctx.formatDate,
          assignedTo: _ctx.formatAssignedTo,
          paymentOption: _ctx.formatPaymentOption,
          collectionStatus: _ctx.formatCollectionStatus,
        },
          onActionOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEditModal($event)))
        }, null, 8, ["query", "query-params", "checkBoxes", "selectAll", "items", "hasCheckBox", "linkableColumns", "formatters"])
      ], 512), [
        [_vShow, _ctx.openedInvoices && _ctx.openedInvoices.length]
      ]),
      _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.t("body.empty")), 513), [
        [_vShow, !_ctx.openedInvoices || !_ctx.openedInvoices.length]
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.t("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isEditModalVisible)
      ? (_openBlock(), _createBlock(_component_EditInvoice, {
          key: 0,
          class: "edit-invoice-modal",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeEditModal())),
          invoice: _ctx.clickedInvoice
        }, null, 8, ["invoice"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _withDirectives(_createVNode(_component_BasicButton, {
        class: "confirm-button",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (
        _ctx.sendSelectedInvoicesToFinancialOfficer(
          _ctx.openedInvoices,
          _ctx.checkBoxes,
          _ctx.selectAll,
        )
      ), ["prevent"])),
        disabled: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("buttons.sendToFinancialOfficer")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]), [
        [_vShow, _ctx.hasCheckBox]
      ])
    ])
  ], 64))
}